import React from 'react'
import { View, TouchableOpacity, ActivityIndicator } from 'react-native'
import { useTheme } from 'styled-components/native'

import Styles from './style'
import ToggleSwitch from 'APP/Converse/Inputs/ToggleSwitch'
import Typography from 'APP/Converse/Typography'

export interface Props {
  title?: string
  description?: string
  label?: string
  disabled?: boolean
  isLoading?: boolean
  isToggled: boolean
  onToggleChange(): void
  testID?: string
}

const ToggleCard = ({
  title,
  description,
  label,
  disabled = false,
  isLoading = false,
  isToggled = false,
  onToggleChange,
  testID = 'TOGGLE_CARD',
}: Props) => {
  const { colors } = useTheme()

  return (
    <TouchableOpacity
      testID={testID}
      style={Styles.section}
      onPress={onToggleChange}
      disabled={disabled || isLoading}
      // @ts-expect-error TouchableOpacity might not have the prop but it supports it
      tabIndex={-1}
    >
      <View style={Styles.container}>
        {title && description && (
          <View style={Styles.textContainer}>
            <Typography variant="h3" testID="TOGGLE_CARD_TITLE">
              {title}
            </Typography>
            <Typography
              variant="bodySmall"
              style={Styles.description}
              testID="TOGGLE_CARD_DESCRIPTION"
            >
              {description}
            </Typography>
          </View>
        )}
        {isLoading && (
          <ActivityIndicator
            animating
            color={colors.text}
            size={'small'}
            style={Styles.loading}
            testID="TOGGLE_LOADING"
          />
        )}
        {!isLoading && (
          <View style={Styles.toggleSwitchContainer}>
            <Typography variant="subheader">{label}</Typography>
            <ToggleSwitch
              checked={isToggled}
              onValueChange={onToggleChange}
              disabled={disabled}
              testID={`${testID}_TOGGLE_SWITCH`}
              label={label}
            />
          </View>
        )}
      </View>
    </TouchableOpacity>
  )
}

export default ToggleCard
